import styled, { css } from 'styled-components';
import { mq } from '~/styles/grid';
import Icon from '../Icon';

export const NotificationStyledIcon = styled(Icon)``;

export const NotificationContainer = styled.div`
  overflow: hidden;
  display: flex;
  width: 50%;
  & .notification-wrapper {
    position: relative;
  }

  & .notification-arrow {
    width: 0;
    height: 0;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-bottom: 8px solid rgb(185, 7, 57);
    position: absolute;
    left: 5px;
    animation: slide-in-right 0.8s both;
  }

  & .notification-content {
    color: white;
    gap: 20px;
    margin: 10px 0px;
    background-color: ${({ type, theme }) => {
      if (type === 'ERROR') return 'rgb(185, 7, 57)';
      if (type === 'SUCCESS') return theme.color.brandSuccess500;
      return 'rgb(185, 7, 57)';
    }};
    padding: 5px 20px;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    max-width: 500px;
    z-index: 996;
    animation: slide-in-right 0.8s both;

    ${({ position }) => {
      if (position === 'fixed') {
        return css`
          position: fixed;
          right: 0px;
          bottom: 20px;
          border-radius: 3px 0px 0px 3px;
        `;
      }
      return css`
        position: relative;
        margin-top: 5px;
        border-radius: 3px;
      `;
    }}
  }

  & svg {
    height: 18px;
    width: 18px;
    fill: white;
  }

  @media (${mq.mdDown}) {
    width: 100%;
    & .notification-content {
      height: fit-content;
      width: 100%;
      justify-content: center;
      ${({ position }) => {
        if (position === 'fixed') {
          return css`
            bottom: -10px;
          `;
        }
        return css``;
      }}
    }
  }

  @keyframes slide-in-right {
    0% {
      transform: translateX(1000px);
      opacity: 0;
    }
    100% {
      transform: translateX(0);
      opacity: 1;
    }
  }
`;
